<template>
  <div>
    <v-progress-linear
      v-if="isLoading"
      class="mt-5 mb-7"
      indeterminate
      rounded
    />

    <div v-else>
      <h6 class="text-uppercase grey--text">
        {{ $t('partner.label.name') }}
      </h6>
      <p class="body-2">
        {{ partner && partner.name ? partner.name : '---' }}
      </p>

      <h6 class="text-uppercase grey--text">
        {{ $t('partner.label.dateCreated') }}
      </h6>
      <p class="body-2">
        {{ partner && partner.date_created ? formatDate(partner.date_created) : '---' }}
      </p>

      <h6 class="text-uppercase grey--text">
        {{ $t('partner.label.description') }}
      </h6>
      <p class="body-2">
        {{ partner && partner.description ? partner.description : '---' }}
      </p>

      <h6 class="text-uppercase grey--text">
        {{ $t('partner.label.historyEmail') }}
      </h6>
      <p class="body-2">
        {{ partner && partner.history_email ? partner.history_email : '---' }}
      </p>

      <h6 class="text-uppercase grey--text">
        {{ $t('partner.label.asaasWalletId') }}
      </h6>
      <v-chip class="mt-2" small>
        <span class="body-2">
          {{ partner && partner.asaas_wallet_id ? partner.asaas_wallet_id : '---' }}
        </span>
      </v-chip>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { catalogDate } from '@/util/catalog'

export default {
  name: 'PartnerDetails',

  computed: {
    ...mapGetters(['partner', 'isLoading']),
  },

  data() {
    return {
      formatDate: catalogDate,
    }
  },
}
</script>
